import {useEffect} from 'react';

import {setContentForm, setInit} from '../store';

type Dispatch = (value: any) => void;

export function useInitBlock(uid: string | undefined, content: any, contentDispatch: Dispatch): any {
  /*
   * `contentDispatch` is a function created by React `useReducer`
   */
  useEffect(() => {
    /*
     * Initial load on edit
     */
    if (uid) {
      contentDispatch(setContentForm(content));
    } else if (!uid && !!content.from_block_id) {
      /*
       * Comes from saved block / duplicate
       */
      contentDispatch(setContentForm(content));
    } else {
      contentDispatch(setInit(true));
    }
  }, []);
}
